import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ResetDemoDataButton } from "@/components/ResetDemoData";

const inp = "bg-zinc-950 border-zinc-800 text-white";

export default function AdminAccount() {
  const nav = useNavigate();
  const [me, setMe] = useState(null);
  const [f, setF] = useState({ current_password: "", email: "", new_password: "", confirm: "" });
  useEffect(() => { adminApi.get("/admin/me").then((r) => { setMe(r.data); setF((s) => ({ ...s, email: r.data.email })); }); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (f.new_password && f.new_password !== f.confirm) { toast.error("As senhas não coincidem"); return; }
    try {
      const body = { current_password: f.current_password };
      if (f.email && f.email !== me.email) body.email = f.email;
      if (f.new_password) body.new_password = f.new_password;
      const r = await adminApi.patch("/admin/account", body);
      toast.success("Credenciais atualizadas. Entre novamente.");
      localStorage.removeItem("pg_admin_token");
      nav("/admin-master/login", { state: { email: r.data.email } });
    } catch (err) { toast.error(err.response?.data?.detail || "Erro ao salvar"); }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-account-page">
      <h1 className="font-display text-3xl font-extrabold">Minha conta</h1>
      <Card className="bg-zinc-900 border-zinc-800"><CardContent className="p-6">
        <h2 className="font-bold text-lg mb-1">Credenciais de acesso</h2>
        <p className="text-sm text-zinc-400 mb-5">Altere o e-mail e/ou a senha usados para entrar no Admin Master. É obrigatório informar a senha atual.</p>
        <form onSubmit={save} className="space-y-4">
          <div><Label className="text-zinc-300">E-mail de acesso</Label>
            <Input className={inp} type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-account-email" /></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label className="text-zinc-300">Nova senha (mín. 12 caracteres)</Label>
              <Input className={inp} type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} placeholder="Deixe vazio para manter" data-testid="admin-account-new-password" /></div>
            <div><Label className="text-zinc-300">Confirmar nova senha</Label>
              <Input className={inp} type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="admin-account-confirm-password" /></div>
          </div>
          <div><Label className="text-zinc-300">Senha atual *</Label>
            <Input className={inp} type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="admin-account-current-password" /></div>
          <Button type="submit" className="bg-emerald-500 hover:bg-emerald-600 text-zinc-950" data-testid="admin-account-save">Salvar alterações</Button>
        </form>
      </CardContent></Card>

      <Card className="bg-zinc-900 border-rose-900/60"><CardContent className="p-6">
        <h2 className="font-bold text-lg text-rose-400 mb-1">Zona de perigo</h2>
        <p className="text-sm text-zinc-400 mb-4">Apaga todas as empresas, usuários, pedidos, produtos e pagamentos de demonstração. Planos, cupons SaaS, configuração do gateway e sua conta admin são mantidos.</p>
        <ResetDemoDataButton />
      </CardContent></Card>
    </div>
  );
}
